export const logging = {
  error: (...args: any[]) => {
    if (window.location.hostname === 'localhost' || process.env.DEBUG) console.error(...args)
  },
  log: (...args: any[]) => {
    if (window.location.hostname === 'localhost' || process.env.DEBUG) console.log(...args)
  }
}
